<section class="toolbar">
	<svg-icon class="logo" key="firestone-logo"></svg-icon>
	<app-download-button class="download-button" [id]="'toolbar-button'"></app-download-button>
</section>
